import { get, set } from 'lodash';
import { getJson, setJson } from 'shared-base';

const PLAYGROUND_KEY = 'playground';

type Project = Record<string, any>; // Replace with a stricter interface if needed

export const local = {
  projects: {
    get: (): Project => {
      return getJson(PLAYGROUND_KEY) ?? {};
    },

    create: (payload: Project) => {
      setJson(PLAYGROUND_KEY, payload);
      return Promise.resolve({ isSuccess: true });
    },

    patch: (_projectId: string, payload: Partial<Project>) => {
      const project = getJson(PLAYGROUND_KEY) ?? {};
      const updated = { ...project, ...payload };
      setJson(PLAYGROUND_KEY, updated);
    },

    patchModel: (_projectId: string, id: string, payload: any) => {
      const project = getJson(PLAYGROUND_KEY) ?? {};
      const model = get(project, ['models', id]) ?? {};
      set(project, ['models', id], { ...model, ...payload });
      setJson(PLAYGROUND_KEY, project);
    },

    clear: (_projectId: string) => {
      setJson(PLAYGROUND_KEY, {});
    },

    removeModel: (_projectId: string, id: string) => {
      const project = getJson(PLAYGROUND_KEY) ?? {};
      if (project.models) {
        delete project.models[id];
      }
      setJson(PLAYGROUND_KEY, project);
    },

    addModel: (_projectId: string, payload: any) => {
      const project = getJson(PLAYGROUND_KEY) ?? {};
      set(project, ['models', payload.id], payload);
      setJson(PLAYGROUND_KEY, project);
    },

    patchModelValues: (_projectId: string, modelId: string, payload: any) => {
      const project = getJson(PLAYGROUND_KEY) ?? {};
      const values = get(project, ['models', modelId, 'valuesModel']) ?? {};
      set(project, ['models', modelId, 'valuesModel'], { ...values, ...payload });
      setJson(PLAYGROUND_KEY, project);
    },
    setModels: (_projectId: string, payload: any) => {
      const project = getJson(PLAYGROUND_KEY) ?? {};
      set(project, ['models'], payload);
      setJson(PLAYGROUND_KEY, project);
    },
  },
};
